import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Title from 'components/Text/Title';
import InvoiceInfo from '../InvoiceInfo/InvoiceInfo';
export default function InvoiceList({
  filteredResults
}) {
  const {
    t
  } = useTranslation();
  if (!filteredResults) return /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('invoices.no_invoice'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, filteredResults?.map(result => /*#__PURE__*/React.createElement(InvoiceInfo, _extends({
    key: result.invoiceNumber
  }, result))));
}